import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AdminService } from '../../services/admin.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-supplier-popup',
  templateUrl: './supplier-popup.component.html',
  styleUrls: ['./supplier-popup.component.scss']
})
export class SupplierPopupComponent implements OnInit {

  editSupplierForm!: FormGroup;
  user!: any;
  vendor_code: any;
  userId: any;

  constructor(private fb: FormBuilder,
    public bsModalRef: BsModalRef,
    public _adminService: AdminService,
    private _toasterService: ToastrService
  ) { }

  ngOnInit(): void {
    console.log("user details", this.user)
    this.vendor_code = this.user.employee_code;
    this.userId = this.user.id;

    this.editSupplierForm = this.fb.group({
      'plant_code': ['', Validators.required],
      'purchase_organization': ['', Validators.required],
      'purchase_group': [''],
      'isEnableDelivery': [true],
      'isEnableConfirmation': [true],
      'isEnableConfirmOverDue': [true],
      'isEnableDeliverOverDue':[true],
      'sendDeliveryFrequency': ['', Validators.required],
      'sendConfirmationFrequency':['', Validators.required],
      'includeTransportationTime':['', Validators.required],
      'deliveryReminderFirst':[1, Validators.required],
      'deliveryReminderSecond':[1, Validators.required],
      'confirmaReminder':[1, Validators.required],
      'confirmOverDueReminder':[1, Validators.required],
    });
    
    this._adminService.getVendorNotification(this.userId).subscribe(res=>{
      console.log("data is present - res",res.data[0].notification_config);
      const data = res.data[0].notification_config
      if (data !== null) {
        this.editSupplierForm.patchValue({
          plant_code: data.plant_code,
          purchase_organization: data.purchase_organization,
          purchase_group: data.purchase_group,
          isEnableDelivery: data.isEnableDelivery,
          isEnableConfirmation: data.isEnableConfirmation,
          isEnableConfirmOverDue: data.isEnableConfirmOverDue,
          isEnableDeliverOverDue: data.isEnableDeliverOverDue,
          sendDeliveryFrequency: data.sendDeliveryFrequency,
          sendConfirmationFrequency: data.sendConfirmationFrequency,
          includeTransportationTime: data.includeTransportationTime,
          deliveryReminderFirst: data.deliveryReminderFirst,
          deliveryReminderSecond: data.deliveryReminderSecond,
          confirmaReminder: data.confirmaReminder,
          confirmOverDueReminder: data.confirmOverDueReminder,
        });
        console.log("Form value after patchValue:", this.editSupplierForm.value);
      }
    })
  }

  ensureChecked(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    if (!checkbox.checked) {
      checkbox.checked = true;
      this.editSupplierForm.get(checkbox.id)?.setValue(true);
    }
  }

  onModalClose() {
    this.bsModalRef.hide();
  }

  SaveDetails() {
    if (this.editSupplierForm.valid) {
      const formValues = { ...this.editSupplierForm.value };

      formValues['vendor_code'] = this.vendor_code;
      delete formValues['purchase_group'];
      console.log("formValues",formValues);

      this._adminService.updateVendorNotification(formValues).subscribe(res => {
        console.log("res", res);
        this._toasterService.success(res.message);
        this.bsModalRef.hide();
      },
        (err: any) => {
          this._toasterService.error(err.error);
        })
    }
  }
}
